import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  toggleTheme: () => void;
  applyTheme: () => void;
  isDark: () => boolean;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light',
      toggleTheme: () => {
        const next: Theme = get().theme === 'light' ? 'dark' : 'light';
        set({ theme: next });
        if (typeof document !== 'undefined') {
          document.documentElement.classList.toggle('dark', next === 'dark');
        }
      },
      applyTheme: () => {
        if (typeof document !== 'undefined') {
          document.documentElement.classList.toggle('dark', get().theme === 'dark');
        }
      },
      isDark: () => get().theme === 'dark',
    }),
    { name: 'randori-mail-theme' },
  ),
);
